<template>
<div>
  <div v-if="loading">
    <Loading> </Loading>
  </div>
<div v-if="!loading">
<v-container fluid>
<v-card-title>
    <v-spacer></v-spacer> <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field> 
</v-card-title>
<br/>
    <v-data-table
      :headers="headers"
      :items="getBookings"
      :search="search"
      class="elevation-1"
    >
    </v-data-table>
</v-container>
</div>
</div>
</template>
<script>
import Loading from '@/components/Loading';

export default {
  name: 'BookingTable',
 components: {
    Loading
  },
  data() {
    return {
      headers: [
        {
          text: 'Booking',
          align: 'start',
          sortable: true,
          value: 'order',
          filterable: true,
        },
        { text: 'Date', value: 'date' },
        { text: 'Address', value: 'address' },
        { text: 'Waste', value: 'wasteName' },
        { text: 'Vehicle', value: 'vehicleName' },
        { text: 'Driver', value: 'driverName' },
        { text: 'Type', value: 'type' },
        { text: 'Status', value: 'status' },
        { text: 'Charge (ZAR)', value: 'cost' }
      ],
      search: '',
    }
  },
  computed: {
    loading(){
      return this.$store.getters.getLoading;
    },
    getUser() {
      return this.$store.getters['auth/getUser'];
    },
    getBookings(){
      return this.$store.getters.getClientTableData;
    }
  },
  methods: {
    loadMore(){
      this.$store.dispatch('fetchClientBookings', this.query); 
    },
  },
  mounted() {
    if(this.getBookings.length === 0){
      this.$store.dispatch('fetchClientBookings', this.getUser.id); 
    }
  }
}
</script>

<style scoped>

</style>